export default function Paragraph({ children }) {
  return <p className=" py-2 text-gray-800 text-md font-normal">{children}</p>;
}
